export const generateFormCss = () => `.container {
  border: 1px solid #cccccc;
  margin: 0 auto;
  padding: 10px;
  background-color: #ffffff;
}
body {
  background-color: #eeeeee;
  padding: 10px;
}`;